/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RemoveMemberRequest } from '../../models/remove-member-request';

export interface OrganizationMembersOrganizationUserIdDelete$Params {
  organizationUserId: string;
      body?: RemoveMemberRequest
}

export function organizationMembersOrganizationUserIdDelete(http: HttpClient, rootUrl: string, params: OrganizationMembersOrganizationUserIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, organizationMembersOrganizationUserIdDelete.PATH, 'delete');
  if (params) {
    rb.path('organizationUserId', params.organizationUserId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

organizationMembersOrganizationUserIdDelete.PATH = '/organization/members/{organizationUserId}';
